<!-- eslint-disable prefer-destructuring -->
<template>
  <div
    class="mbSection"
    :style="!measures.showMassBalance && 'color: #DCDCDC; border-color: gray;'"
  >
    <!--                                       HEADER                               -->
    <div class="mbSection__header">
      <div class="mbSection__header__left">
        <span class="mbSection__header__title">
          {{ measures.name }}
        </span>
        <div
          class="mbSection__header__date"
          :style="!measures.showMassBalance && 'color: #DCDCDC;'"
        >
          {{ moment(measures.previousWODate).format('YYYY-MM-DD') }} - {{ moment(measures.currentWODate).format('YYYY-MM-DD') }}
        </div>
      </div>
      <div class="mnSection__header__button">
        <v-menu offsetY>
          <template #activator="{ on, attrs }">
            <v-btn
              xSmall
              fab
              rounded
              color="primary"
              v-bind="attrs"
              class="mnSection__header__menuButton"
              v-on="on"
            >
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              v-for="action in actions"
              :key="action.id"
              @click="action.handler"
            >
              <v-icon left>
                {{ action.icon }}
              </v-icon>
              <v-list-item-title>{{ action.label }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </div>
    <!--                                  ANALYSES                                  -->
    <div class="mbSection__analyses">
      <div
        :class="`mbSection__analyses__header ${!measures.showMassBalance ?
          'mbSection__analyses__header__active' : 'mbSection__analyses__header__inActive'}`"
      >
        {{ $t('massBalance.sectionWO.parameters') }}
      </div>
      <div class="mbSection__analyses__content">
        <!-- Total days -->
        <div class="mbSection__analyses__body">
          <div class="mbSection__analyses__body__lign">
            <div style="width: 50%;">
              {{ $t('massBalance.sectionWO.totalDays') }}
            </div>
            <div style="width: 50%;">
              {{ isNumber(measures.totalDays) ? measures.totalDays : '' }}
            </div>
          </div>
        </div>
        <!-- Make Up -->
        <div class="mbSection__analyses__body">
          <div class="mbSection__analyses__body__lign">
            <div style="width: 50%;">
              {{ $t('massBalance.sectionWO.makeUp') }}
            </div>
            <div :style="measures.MU[0] === null ? 'width: 50%;' : 'width: 25%;'">
              {{ isNumber(measures.MU[1]) ? measures.MU[1].toLocaleString() + ' ' + massBalanceUnits.volume : '' }}
            </div>
            <div
              v-if="measures.MU[0] !== null"
              style="width: 25%;"
            >
              {{ isNumber(measures.MU[0]) ? measures.MU[0].toLocaleString() + ' ' + massBalanceUnits.mass : '' }}
            </div>
          </div>
        </div>

        <!-- Evaporation -->
        <div class="mbSection__analyses__body">
          <div class="mbSection__analyses__body__lign">
            <div style="width: 50%;">
              {{ $t('massBalance.sectionWO.evaporation') }}
            </div>
            <div :style="measures.EV[0] === null ? 'width: 50%;' : 'width: 25%;'">
              {{ isNumber(measures.EV[1]) ? measures.EV[1].toLocaleString() + ' ' + massBalanceUnits.volume : '' }}
            </div>
            <div
              v-if="measures.EV[0] !== null"
              style="width: 25%;"
            >
              {{ isNumber(measures.EV[0]) ? measures.EV[0].toLocaleString() + ' ' + massBalanceUnits.mass : '' }}
            </div>
          </div>
        </div>

        <!-- blowdown -->
        <div class="mbSection__analyses__body">
          <div class="mbSection__analyses__body__lign">
            <div style="width: 50%;">
              {{ $t('massBalance.sectionWO.blowdown') }}
            </div>
            <div :style="measures.BD[0] === null ? 'width: 50%;' : 'width: 25%;'">
              {{ isNumber(measures.BD[1]) ? measures.BD[1].toLocaleString() + ' ' + massBalanceUnits.volume : '' }}
            </div>
            <div
              v-if="measures.BD[0] !== null"
              style="width: 25%;"
            >
              {{ isNumber(measures.BD[0]) ? measures.BD[0].toLocaleString() + ' ' + massBalanceUnits.mass : '' }}
            </div>
          </div>
        </div>

        <!-- Cycles -->
        <div class="mbSection__analyses__body">
          <div class="mbSection__analyses__body__lign">
            <div style="width: 50%;">
              {{ $t('massBalance.sectionWO.cycles') }}
            </div>
            <div style="width: 50%;">
              {{ isNumber(measures.CoC) ? measures.CoC.toLocaleString() : '' }}
            </div>
          </div>
        </div>

        <!-- Hydraulic -->
        <div
          v-if="isNumber(measures.HydraulicCycles)"
          class="mbSection__analyses__body"
        >
          <div class="mbSection__analyses__body__lign">
            <div style="width: 50%;">
              {{ $t('massBalance.sectionWO.hydraulicCycles') }}
            </div>
            <div style="width: 50%;">
              {{ measures.HydraulicCycles.toLocaleString() }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--                                         PRODUCTS                                     -->
    <div class="mbSection__products">
      <div :class="`mbSection__products__header ${!measures.showMassBalance ? 'inActivBar' : 'activBar'}`">
        <div :class="`${!measures.showMassBalance ? 'mbSection__products__header__active' : 'mbSection__products__header__inActive'}`">
          {{ $t('massBalance.sectionWO.products') }}
        </div>
        <div :class="`${!measures.showMassBalance ? 'mbSection__products__header__active' : 'mbSection__products__header__inActive'}`">
          {{ $t('massBalance.sectionWO.quantities') }}
        </div>
        <div :class="`${!measures.showMassBalance ? 'mbSection__products__header__active' : 'mbSection__products__header__inActive'}`">
          {{ $t('massBalance.sectionWO.realPPM') }}
        </div>
        <div :class="`${!measures.showMassBalance ? 'mbSection__products__header__active' : 'mbSection__products__header__inActive'}`">
          {{ $t('massBalance.sectionWO.targetPPM') }}
        </div>
      </div>
      <div class="mbSection__products__body">
        <div
          v-for="(item, index) in measures.productParameters"
          :key="index"
          class="mbSection__products__body__row"
        >
          <div>
            {{ item.productName + (item.productConcentration[0] === null ?
              `(${$t('massBalance.sectionWO.active')})` : '') }}
          </div>
          <div>
            {{ item.productConsumptionInReportUnit ? item.productConsumptionInReportUnit.toLocaleString() : '' }}
            {{ item.productConsumptionInReportUnit && item.reportUnit }}
          </div>
          <div>
            {{ item.productConcentration && item.productConcentration.length
              ? item.productConcentration.find(element => element !== null).toLocaleString()
              : ''
            }}
          </div>
          <div>
            {{ item.targetPPM.toLocaleString() }}
          </div>
        </div>
      </div>
    </div>

    <!--                                         E4 savings                                     -->
    <div class="mbSection__analyses eSaving">
      <div
        :class="`mbSection__analyses__header ${!measures.showMassBalance ?
          'inActivBar' : 'activBar'}`"
      >
        {{ $t('massBalance.sectionWO.eSaving') }}
      </div>
      <div class="mbSection__analyses__contentESaving eSavingStyle">
        <!-- Water saving -->
        <div class="mbSection__analyses__body">
          <div class="mbSection__analyses__body__lign">
            <div
              class="eSavingStyleItem"
              style="width: 50%;"
            >
              <TreeCardIcon
                :src="treeIcon('waterSaving', !measures.showMassBalance).icon"
                :alt="treeIcon('waterSaving').alt"
                custumeIconsClass20
              />
              <span class="eSavingStyleItemText">
                {{ $t('massBalance.sectionWO.waterSaving') }}
              </span>
            </div>
            <div
              v-if="measures.FW[0] !== null"
              style="width: 50%;"
            >
              {{ measures.waterSavingsData && isNumber(measures.waterSavingsData.value) ? measures.waterSavingsData.value.toLocaleString() + ' '
                + measures.waterSavingsData.unit : '' }}
            </div>
          </div>
        </div>

        <!-- Cooling efficiency -->
        <div class="mbSection__analyses__body">
          <div class="mbSection__analyses__body__lign">
            <div
              class="eSavingStyleItem"
              style="width: 50%;"
            >
              <TreeCardIcon
                :src="treeIcon('coolingEfficiency', !measures.showMassBalance).icon"
                :alt="treeIcon('coolingEfficiency').alt"
                custumeIconsClass20
              />
              <span class="eSavingStyleItemText">
                {{ $t('massBalance.sectionWO.coolingEfficiency') }}
              </span>
            </div>
            <div
              v-if="measures.C[0] !== null"
              style="width: 50%;"
            >
              {{ measures.coolingTowerEfficiency && isNumber(measures.coolingTowerEfficiency) ? measures.coolingTowerEfficiency + '%' : '' }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      :class="`mbSection__products__body__showOnPDF ${!measures.showMassBalance ?
        'mbSection__products__body__showOnPDF__inActivBar' : 'mbSection__products__body__showOnPDF__activBar'}`"
    >
      <v-switch
        v-model="measures.showOnReport"
        :color="colorActiveOrInactive"
        @change="toggleshowPdfInMeasureMassBalance"
      />
      <div> {{ $t('massBalance.sectionWO.showAllOnPDF') }} </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Vue from 'vue';
import TreeCardIcon from '@/components/component/icons/TreeCardIcon.vue';
import MassBalanceForm from './MassBalanceForm.vue';

export default {
    name: 'Cooling',
    components: {
        TreeCardIcon,

    },
    props: {
        measureDetails: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            measures: {},
            massBalanceUnits: {
                mass: '',
                volume: '',
            },
        };
    },
    computed: {
        ...mapGetters([
            'workOrder',
        ]),
        actions() {
            const actions = [
                {
                    id: 'edit',
                    label: this.$t('forms.btn.edit'),
                    handler: this.onEdit,
                    icon: 'mdi-pencil',
                },
                {
                    id: 'disable',
                    label: this.measures.showMassBalance ? this.$t('forms.btn.deactivate') : this.$t('forms.btn.activate'),
                    handler: this.onToggleActiveDeactive,
                    icon: this.measures.showMassBalance ? 'mdi-eye-off' : 'mdi-eye',
                },
            ];

            return actions;
        },
        colorActiveOrInactive() {
            return this.measures.showMassBalance ? 'primary' : '#DCDCDC';
        },
    },
    watch: {
        measureDetails: {
            handler() {
                this.measures = this.measureDetails;
            },
            deep: true,
            immediate: true,
        },
    },
    mounted() {
        this.getUnitsForAllMeasures();
    },
    methods: {
        treeIcon(iconName, isDisable) {
            const name = isDisable ? `${iconName}Disable` : iconName;
            return {
                icon: `/assets/${name}.svg`,
                alt: iconName,
            };
        },
        getUnitsForAllMeasures() {
            // eslint-disable-next-line prefer-destructuring
            this.massBalanceUnits.mass = this.measures.massBalanceUnits[0];
            // eslint-disable-next-line prefer-destructuring
            this.massBalanceUnits.volume = this.measures.massBalanceUnits[1];
        },
        toggleshowPdfInMeasureMassBalance() {
            this.$emit('change', this.measures.id, this.measures.showOnReport);
        },
        onEdit() {
            this.$root.$emit('showModal', {
                title: `${this.$t('massBalance.editMassBalance')} - ${this.measures.name}`,
                component: Vue.component('MassBalanceForm', MassBalanceForm),
                payload: {
                    massBalanceId: this.measures.id,
                    workOrderId: this.workOrder.id,
                },
                onConfirm: requestPayload => this.editMassBalance(requestPayload),
                isForm: true,
            });
        },
        async onToggleActiveDeactive() {
            // eslint-disable-next-line max-len
            await this.$rq.toggleshowPdfInMeasureMassBalance(this.workOrder.id, this.measures.id, { showMassBalance: !this.measures.showMassBalance });
            this.$emit('updateActiveDeactive');
        },

        editMassBalance(datasMassBalance) {
            const { selectedComponents, components } = datasMassBalance;
            const ignoredComponents = components
                .map(component => component.id) // Extraire tous les IDs de components
                .filter(id => !selectedComponents.includes(id)); // Exclure ceux présents dans selectedComponents

            this.$rq.updateMassBalanceInfos(this.workOrder.id, this.measures.id, { ignore: ignoredComponents });
        },
        isNumber(value) {
            return typeof value === 'number' && !Number.isNaN(value);
        },
    },
};
</script>
  <style lang="scss" scoped>
  @import "@/assets/styles/components/massBalanceWorkOrder.scss";
      .mbSection {
          &__analyses {
              &__content{
                  height: 150px;
              }
              &__contentESaving{
                  height: 65px;
              }
          }
      }
  </style>
